import type { InteractionType } from '~/model/InteractionType';
import { VpButton } from '@vtmn-play/react/headless';
import { useTranslations } from 'next-intl';
import { BeardmanNoContent } from '~/components/Beardman/BeardmanNoContent/BeardmanNoContent';
import { isAuthenticatedAsMainUser } from '~/utils/user/user';
import { useAuthenticatedContext } from '../../Provider';

export const CommentBanner = ({ interaction }: { interaction: InteractionType }) => {
  const t = useTranslations();

  const { user, isAuthenticated, redirectToLogin } = useAuthenticatedContext();

  const canComment = isAuthenticatedAsMainUser(user, isAuthenticated);
  const hasContributions = !!interaction.contributions_count;

  const label = hasContributions
    ? 'COMMENT_BANNER.BODY.WITH_CONTRIBUTIONS'
    : 'COMMENT_BANNER.BODY.WITHOUT_CONTRIBUTIONS';

  return (
    <div data-testid="comment-banner" className="comment-banner">
      {!hasContributions && <BeardmanNoContent />}
      <div className="comment-banner__content">
        <span className="vp-body-l">{t(label)}</span>
        {!canComment && (
          <VpButton
            onClick={async () => await redirectToLogin()}
          >
            {t('GLOBAL.LOGIN_OR_CREATE_ACCOUNT')}
          </VpButton>
        )}
      </div>
    </div>
  );
};
